module.exports = __webpack_public_path__ + "static/img/loginMessBg.d9d2cf34.png";